<template>
  <div class="store-locator__map">
    <component
      :is="computedType"
      :options="options"
      :stores="stores"
    ></component>
  </div>
</template>

<script>
import GoogleMap from './google-map';
import OpenStreetMap from './open-street-map';

export default {
  components: {
    'cp-google-map': GoogleMap,
    'cp-open-street-map': OpenStreetMap,
  },
  name: 'cp-map',
  props: {
    options: {
      required: true,
      type: Object,
    },
    stores: {
      required: true,
      type: Array,
    },
    type: {
      required: true,
      type: String,
    },
  },
  computed: {
    computedType() {
      return 'cp-' + this.type;
    },
  },
  mounted() {
    this.trace('{map.vue} mounted');
  },
};
</script>
